import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Shipment Group', 'Description'];

export const ShipmentGroupDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;
  const { options: shipmentGroupOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'description',
    valueAttribute: 'shipmentGroup',
    params: {
      windowId: 'shipmentGroups',
    },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={shipmentGroupOptions} columnNames={COLUMN_NAMES} />;
};
